import {React}  from 'react';
import {FaEnvelope} from 'react-icons/fa';

const Footer = () => {
    return (
      <footer className="text-[#25292C] py-4 bg-[#EFF8E2]" >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div>
        <p>Nova Auto Detailing &copy; 2024</p>
        <p>Phone: (206) 766-0409</p>
        </div>
        <div className='items-end'>
        <a href="mailto:" className="hover:text-gray-800">
          <FaEnvelope size={21}/>
        </a>
        </div>
      </div>
      </footer>
    );
};

export default Footer;
